import { calculateEQ5DTotalValue as calculateTotal, calculateEQ5DVAS as calculateVAS } from 'neuro-calculation-commons';

export const calculateEQ5DVAS = calculateVAS;

export default calculateTotal;
